import { CreateClientCommand, GetClientsRequest, GetClientsResponse, UpdateClientCommand, DeleteClientCommand } from "../model/clientModel";
import { apiCall, apiCallNoResponse } from "./sharedAsync";


var getClientAbortController: AbortController | undefined = undefined;
export const apiGetClients = async (token: string, payload: GetClientsRequest, rejectWithValue: (value: string)=>void) => {
    if(getClientAbortController !== undefined){
        getClientAbortController.abort();
    }
        
    getClientAbortController = new AbortController();

    return await apiCall<GetClientsResponse, GetClientsRequest>(token, "/client/search/" + (payload.QueryString == "" ? -1 : payload.QueryString), "GET", rejectWithValue, "Failed to search clients.", undefined, getClientAbortController.signal);
}

export const apiCreateClient = async (token: string, payload: CreateClientCommand, rejectWithValue: (value: string)=>void) => {
    return await apiCallNoResponse<CreateClientCommand>(token, "/client/create", "POST", rejectWithValue, "Failed to create client!", payload);
}

export const apiUpdateClient = async (token: string, payload: UpdateClientCommand, rejectWithValue: (value: string)=>void) => {
    return await apiCallNoResponse<UpdateClientCommand>(token, "/client/update", "PUT", rejectWithValue, "Failed to update client!", payload);
}

export const apiDeleteClient = async (token: string, payload: DeleteClientCommand, rejectWithValue: (value: string)=>void) => {
    return await apiCallNoResponse<DeleteClientCommand>(token, "/client/delete", "DELETE", rejectWithValue, "Failed to delete client!", payload);
}